import { render } from "./Ticket.vue?vue&type=template&id=7c06bac9"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"

import "./Ticket.vue?vue&type=style&index=0&id=7c06bac9&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__